// extracted by mini-css-extract-plugin
export default {"buttons":"CursorPagination_buttons__74E+s"};